
























import Vue from 'vue';
import CustomType from '../../types/vue';

export interface ComponentApp extends Vue {
    newValue: Array<any>
    value: Array<any>
    isRequired: Boolean
    action: (result: Array<any>, Sucess: Boolean) => any
    success: Boolean
    isDisabled: Boolean
    capitalize: (str: string) => string
    translateMessage: (str: string) => string
    name: string
    isTrad: Boolean
}

var component: Vue.ComponentOptions<ComponentApp> = {
    name: 'Checkbox',
    props: {
        placeholder: { type: String, required: false },
        data: { type: Array, required: true },
        value: { type: Array, required: false },
        action: { type: Function, required: true },
        inline: { type: Boolean, required: false, default: false },
        isRequired: { type: Boolean, required: false, default: false },
        isDisabled: { type: Boolean, required: false, default: false },
        isTrad: { type: Boolean, required: false, default: false },
    },
    data: function () {
        return {
            name:  "checkbox" + new Date().getMilliseconds(),
            newValue: this.value
        }
    },
    computed: {
        success: function () {
            if (this.isRequired)
                return this.newValue.length > 0
            else
                return true;             
        },
    },
    watch: {
        newValue: function (val) {
            this.action(val, this.success);
        },
        value: function (val) {
            this.newValue = val
        }
    },
    filters: {
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        }
    },
    methods: {
        translateMessage: function (cle) {
            if (Number.isInteger(parseInt(cle)))
                return cle

            if (cle === "" || cle === undefined || cle === null)
                return "";

             if(this.isTrad)
                return this.translate(this.$language, cle);
            else
                return cle;
        },
    }
}
export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/form/Checkbox.vue